import axios from "./index.service";

export default class EventService {
  static create(payload) {
    return axios({
      method: "POST",
      url: "/api/services/v1/event/create",
      data: payload,
    });
  }

  static fetchAll(payload) {
    return axios({
      method: "GET",
      url: "/api/services/v1/event/list-all",
      params: payload,
    });
  }

  static fetchById(eventId) {
    return axios({
      method: "GET",
      url: `/api/services/v1/event/${eventId}`,
    });
  }

  static fetchEventAttendees(eventId) {
    return axios({
      method: "GET",
      url: `/api/services/v1/event/event-attendees/${eventId}`,
    });
  }

  static update(eventId) {
    return axios({
      method: "PUT",
      url: `/api/services/v1/event/${eventId}`,
    });
  }

  static joinEvent(eventId) {
    return axios({
      method: "PUT",
      url: `/api/services/v1/event/join-event/${eventId}`,
    });
  }

  static leaveEvent(eventId) {
    return axios({
      method: "PUT",
      url: `/api/services/v1/event/leave-event/${eventId}`,
    });
  }

  static delete(eventId) {
    return axios({
      method: "DELETE",
      url: `/api/services/v1/event/${eventId}`,
    });
  }

  static approveOrDisapprove(eventId) {
    return axios({
      method: "PUT",
      url: `/api/services/v1/event/approveOrDisapprove/${eventId}`,
    });
  }
}
